// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6ldnD","name":"styles_name__2vIBl","phone":"styles_phone__3ahxv"};